import {
	IPropsStore,
	MasterPageFeatureConfigSymbol,
	PageFeatureConfigSymbol,
	Props,
	TpaHandlerProvider,
	ViewerModel,
	AppStyleProps,
	AppWidgetData,
	Experiments,
	ExperimentsSymbol,
} from '@wix/thunderbolt-symbols'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { IOoiTpaSharedConfig, OoiTpaSharedConfigSymbol } from 'feature-ooi-tpa-shared-config'
import { CommonConfigSymbol, ICommonConfig } from 'feature-common-config'
import { ITpaLoadMeasure, TpaMasterPageConfig, TpaPageConfig } from '../types'
import { name, TpaLoadMeasureSymbol } from '../symbols'

export type MessageData = { version: string }

export type AppIsAliveResponse = AppStyleProps &
	AppWidgetData & {
		fonts: { cssUrls: any; imageSpriteUrl: string; fontsMeta: any }
		commonConfig: ViewerModel['commonConfig']
		isVisualFocusEnabled: boolean
		siteColors: any
		siteTextPresets: any
	}

export const AppIsAliveHandler = withDependencies(
	[
		named(MasterPageFeatureConfigSymbol, name),
		named(PageFeatureConfigSymbol, name),
		TpaLoadMeasureSymbol,
		CommonConfigSymbol,
		Props,
		OoiTpaSharedConfigSymbol,
		ExperimentsSymbol,
	],
	(
		tpaMasterPageConfig: TpaMasterPageConfig,
		{ widgets }: TpaPageConfig,
		tpaLoadMeasure: ITpaLoadMeasure,
		commonConfigAPI: ICommonConfig,
		props: IPropsStore,
		{ getFontsConfig }: IOoiTpaSharedConfig,
		experiments: Experiments
	): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				appIsAlive(compId: string, msgData, { originCompId }): AppIsAliveResponse {
					const { siteColors, isVisualFocusEnabled, siteTextPresets } = tpaMasterPageConfig
					props.update({
						[compId]: {
							sentAppIsAlive: true,
						},
					})
					tpaLoadMeasure.reportTpaLoadEnd(compId)
					const widgetData = widgets[originCompId] || {
						style: {
							colors: {},
							numbers: {},
							booleans: {},
							fonts: {},
							googleFontsCssUrl: '',
							uploadFontFaces: '',
						},
					}
					const fontsConfig = getFontsConfig()

					const isInlineFontsCSSForIframeTPAEnabled =
						experiments['specs.thunderbolt.inlineFontsCSSForIframeTPA']

					if (
						!isInlineFontsCSSForIframeTPAEnabled &&
						experiments['specs.thunderbolt.iFrameTPACustomFontsCSS']
					) {
						fontsConfig.cssUrls = [
							'//static.parastorage.com/services/fonts-data/dist/fonts.mjtd3c8n2u3hi9zejjn2.css',
							'//static.parastorage.com/services/fonts-data/dist/google.llj7u9yvj7k0dtoedoeb.css',
							'//static.parastorage.com/services/fonts-data/dist/wixMadefor.lhwa62d5phtg3i69bmvs.css',
						]
					}

					if (isInlineFontsCSSForIframeTPAEnabled) {
						/*
						 * Note: CSS for WIX iFrame TPAs should be inlined, so no need to supply CSS as external files
						 * it helps to prevent INP degradation for WIX sites
						 * Required fonts CSS is added to "widgetData.style.uploadFontFaces"
						 * */
						if (widgetData.isWix) {
							fontsConfig.cssUrls = []
						}
					}

					return {
						fonts: fontsConfig,
						commonConfig: commonConfigAPI.getCommonConfig(),
						isVisualFocusEnabled,
						siteColors,
						siteTextPresets,
						...widgetData,
					}
				},
			}
		},
	})
)
